<template>
  <b-modal id="noteModal" ref="noteModal" title="Note per la segnalazione" size="lg" centered scrollable
           no-close-on-backdrop
           no-close-on-esc
           header-bg-variant="dark"
           header-text-variant="light"
           header-close-variant="light"
           ok-title="Salva"
           cancel-title="Annulla"
           cancel-variant="light"
           @ok="saveNote"
           :ok-disabled="noteSaving"
           :cancel-disabled="noteSaving" style="padding: 0">
    <template #modal-header>
      <h5>
        <b-iconstack style="margin-right: 1rem">
          <b-icon stacked icon="file"></b-icon>
          <b-icon stacked icon="pencil-fill" scale="0.8" shift-h="5" shift-v="1"></b-icon>
        </b-iconstack>
        Note per la segnalazione
      </h5>
    </template>
    <template #default="{ hide }">
      <p>Aggiungere o modificare la nota</p>
      <b-form-textarea id="note-text" v-model="editedNote" placeholder="Appunta delle note..." rows="12" max-rows="12"></b-form-textarea>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalNote',
  props: {
    note: { type: String, default: ""},
    warningId: {},
    noteSaving: {},
    eventName: {}
  },
  watch: {
    note: function () {
      this.editedNote = this.note
    }
  },
  data: () => ({
    editedNote: null
  }),
  methods: {
    saveNote() {
      this.$emit(this.eventName, { "warningId": this.warningId, "note": this.editedNote })
      this.editedNote = null
    }
  }
}
</script>
